import type { SlotSymbolDef } from '../../widgets/slot/types';

/** The ids of the special cells a game never shows as a picture. */
const SPECIAL_IDS = ['money', 'bonus', 'item_drop'];

/**
 * The slot's own symbols for a game's pictures (match faces, scratch
 * pictures), lowest first: the first four plain ones and the top one. Wild,
 * scatter and the special cells (money, the reel race's and the gem cells,
 * which a theme made without them has at the end) are left out.
 */
export function gamePictureSymbols(slot: {
  symbols: readonly SlotSymbolDef[];
  wildSymbolId: string;
  scatterSymbolId?: string;
}): (SlotSymbolDef | undefined)[] {
  const plain = slot.symbols.filter(
    (s) =>
      s.id !== slot.wildSymbolId &&
      s.id !== slot.scatterSymbolId &&
      !SPECIAL_IDS.includes(s.id) &&
      (s.gemValue ?? 0) <= 0,
  );
  return [...plain.slice(0, 4), plain[plain.length - 1]];
}
